import * as React from 'react';
import { ParagraphWidget } from '../../widgets/forms/ParagraphWidget';
import { MarketingScreenWidget } from '../../widgets/layout/MarketingScreenWidget';
import { useProductConfig } from '../../hooks/useProduct';
import { getIDEUrl } from '@journeyapps-platform/types-accounts';
import { ENV } from '../../env';
export const SignupMobileWidget: React.FC = () => {
  const product = useProductConfig();
  const url = getIDEUrl({
    env: ENV,
    ide: product.ide
  });
  const urlOb = new URL(url);
  return (
    <MarketingScreenWidget
      title={'Success'}
      subheading={`Your account has been created`}
      content={[
        <ParagraphWidget>
          {`Please log in to ${product.product_name} from a desktop\nand go to `}
          <a href={url}>{urlOb.hostname}</a>
        </ParagraphWidget>
      ]}
    />
  );
};
